import { TableStateType } from "@mm-products/java-multima-framework";
import { PayloadAction } from "@reduxjs/toolkit";
import { Draft } from "immer";

export type TaxTableStateType = TableStateType & { resetIndicator?: number };
export type CommonTableState = {
    tableState: TaxTableStateType;
};
export const updateTableState = (state: Draft<CommonTableState>, action: PayloadAction<TaxTableStateType>, initialState: TaxTableStateType) => {
    const payload = action.payload;
    // empty keys = we want to reset table
    const keys = Object.keys(payload);
    if (keys.length === 0) {
        state.tableState = { ...initialState, resetIndicator: (state.tableState?.resetIndicator ?? 0) + 1 };
        return;
    }
    // filter what we don't want to save
    keys.filter((key) => (key as keyof TableStateType) !== "globalFilter").forEach((key) => {
        const keyType = key as keyof TaxTableStateType;
        if (keyType === "columnPinning") {
            // row actions column always stays pinned as the last one on the right
            const columnPinning = payload.columnPinning;
            state.tableState.columnPinning = {
                ...columnPinning,
                right: [...(columnPinning?.right ?? []).filter((str) => str !== "mrt-row-actions"), "mrt-row-actions"],
            };
        } else {
            (state.tableState as Record<string, unknown>)[keyType] = payload[keyType];
        }
    });
};